const scope = "holder/";

export const fetch_paginated_holders_saga = `${scope}fetch_paginated_holders`;
export const fetch_holder_by_id_saga = `${scope}fetch_holder_by_id`;
export const create_new_holder_saga = `${scope}fetch_create_new_holder`;
export const update_holder_saga = `${scope}update_new_holder_saga`;
export const delete_holder_saga = `${scope}delete_holder_saga`;
export const reset_password_holder_saga = `${scope}reset_password_holder_saga`;
